export type ForceLogoutReason = "refresh_missing" | "refresh_failed";

type Listener = (reason: ForceLogoutReason) => void;

const listeners = new Set<Listener>();

export function onForceLogout(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitForceLogout(reason: ForceLogoutReason) {
  listeners.forEach((listener) => listener(reason));
}
